import { useMemo } from "react";
import { HomeTableAccess } from "../store";
import { ELEMENT_NOT_FOUND } from "@smartrr/shared/constants";
import { HomeTableSorts } from "../store/sorts";

export interface IndexTableSort {
  currentSortColumn: number | undefined;
  direction: "ascending" | "descending";
  sortableColumns: boolean[];
  onSort: (headingIndex: number, direction: "ascending" | "descending") => void;
}

export const useIndexTableHeadingSortInfo = (): IndexTableSort => {
  const selectedColumns = HomeTableAccess.useSelectedColumn();
  const selectedSort = HomeTableAccess.useSelectedSort();
  const tableActions = HomeTableAccess.useActions();

  const enabledColumns = useMemo(() => {
    return selectedColumns.filter(c => c.value);
  }, [selectedColumns]);

  return useMemo(() => {
    const currentSortColumnIndex = enabledColumns.findIndex(c => c.columnType === selectedSort.sortType);

    return {
      currentSortColumn: currentSortColumnIndex === ELEMENT_NOT_FOUND ? undefined : currentSortColumnIndex,
      direction: selectedSort.value === "ASC" ? "ascending" : "descending",
      onSort(headingIndex, direction) {
        const chosenColumn = enabledColumns[headingIndex];
        if (!chosenColumn) {
          return;
        }

        const sortType = HomeTableSorts.schema.safeParse(chosenColumn.columnType);

        if (sortType.success) {
          tableActions.sort.select({
            sortType: HomeTableSorts.SortInfo[sortType.data].name,
            value: direction === "ascending" ? "ASC" : "DESC",
          });
        }
      },
      sortableColumns: enabledColumns.map(c => !!HomeTableSorts.SortInfo[c.columnType]),
    };
  }, [enabledColumns, selectedSort]);
};
